import { db, type OfflineAttachment } from './db';

/** Store (or overwrite) an offline attachment blob. */
export async function putAttachment(attachment: OfflineAttachment): Promise<void> {
  await db.attachments.put(attachment);
}

/** Load an attachment by its id. */
export async function getAttachment(id: string): Promise<OfflineAttachment | undefined> {
  return db.attachments.get(id);
}

/** Delete every attachment owned by a given outbox entry (its idempotencyKey).
 *  `target` lets replayCore free blobs through an injected database (the
 *  service worker's own Dexie handle, a test's) — default is the app's. */
export async function deleteAttachmentsForOutbox(
  outboxKey: string,
  target: { attachments: typeof db.attachments } = db,
): Promise<void> {
  await target.attachments.where('outboxKey').equals(outboxKey).delete();
}
